import { baseApi } from "../baseApi";
import {
  ConsentCredentialsResponse,
  ConsentVerifyRequest,
  ConsentVerifyResponse
} from "./type";

export const consentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    consentCredentials: build.query<ConsentCredentialsResponse, void>({
      query: () => ({
        url: "/youth/consent-credentials",
        method: "GET",
      }),
    }),
    consentVerify: build.mutation<ConsentVerifyResponse, ConsentVerifyRequest>({
      query: (body: ConsentVerifyRequest) => ({
        url: "/youth/consent/verify",
        method: "POST",
        body,
      }),
    }),
    consentAllow: build.mutation<any, any>({
      query: (body: any) => ({
        url: "/youth/consent/allow",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useConsentCredentialsQuery,
  useConsentVerifyMutation,
  useConsentAllowMutation,
} = consentApi;
